<template>
  <a-modal :forceRender="true" :visible="value" :title="title" :maskClosable="true" :closable="closable" :destroyOnClose="true" @cancel="handleCancel" @ok="handleOk" :width="width" :keyboard="true">
    <slot></slot>
    <template #footer>
      <slot name="footer">
        <a-button v-if="showCancel" @click="handleCancel">{{ cancelText }}</a-button>
        <a-button v-if="showConfirm" type="primary" :loading="confirmLoading" @click="handleOk">{{ confirmText }}</a-button>
      </slot>
    </template>
  </a-modal>
</template>

<script>
export default {
  props: {
    value: Boolean,
    title: {
      type: String,
      default: '提示'
    },
    closable: {
      type: Boolean,
      default: true
    },
    showCancel: {
      type: Boolean,
      default: true
    },
    cancelText: {
      type: String,
      default: '取 消'
    },
    showConfirm: {
      type: Boolean,
      default: true
    },
    confirmText: {
      type: String,
      default: '确 定'
    },
    confirmLoading: {
      type: Boolean,
      default: false
    },
    width: {
      type: [String, Number],
      default: null
    },

  },
  methods: {
    handleCancel () {
      this.$emit('input', false); // 触发 v-model 更新
      this.$emit('cancel');
    },
    handleOk () {
      this.$emit('confirm');
    }
  }
};
</script>
